import { Booth } from '../../../../../../../interfaces/interfaces';
import BoothStats from './BoothStats';
import { TabContentWrapper } from './TabContentWrapper';

interface AnalyticsTabInterface {
  booth: Booth;
}

const AnalyticsTab = ({ booth }: AnalyticsTabInterface) => {
  return (
    <TabContentWrapper>
      <BoothStats booth={booth} />
    </TabContentWrapper>
  );
};
export default AnalyticsTab;
